import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative"
}
const _hoisted_2 = ["src"]

import { store } from "@/state/store";
import useIsMobile from "@/services/detectingMobile";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageModalDesktop',
  props: {
    imgSource: {}
  },
  setup(__props: any) {

const { isMobile } = useIsMobile();



return (_ctx: any,_cache: any) => {
  return (!_unref(store).isLandingPage && !_unref(isMobile))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.imgSource)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "h-full w-full object-cover",
              src: _ctx.imgSource,
              alt: "",
              loading: "lazy"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})